<template>
  <div id="main">
    <div class="main-content">
      <div class="detail">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoHeaderFooterLayout",
};
</script>

<style lang="scss" scoped>
#main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.logo-container {
  width: 100px;
}
.main-content {
  display: flex;
  flex: 1;

  .detail {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .detail {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
